const description = {
    email: 'อีเมล',
    phone_number: 'หมายเลขโทรศัพท์',
    username: 'ชื่อผู้ใช้',
    reminder: 'การแจ้งเตือน',
    not_found: '404 ไม่พบหน้านี้',
    agree_with_terms: 'ข้าพเจ้าได้อ่านและยอมรับ ',
    agree_with_terms_modal: 'ในการดำเนินการต่อ โปรดยอมรับ <link></link>.',
    terms_of_use: 'ข้อกำหนดการใช้งาน',
    sign_in: 'เข้าสู่ระบบ',
    privacy_policy: 'นโยบายความเป็นส่วนตัว',
    create_account: 'สร้างบัญชี',
    switch_account: 'สลับบัญชี',
    or: 'หรือ',
    and: 'และ',
    enter_passcode: 'รหัสยืนยันได้ถูกส่งไปยัง {{address}} {{target}} แล้ว',
    passcode_sent: 'ได้ส่งรหัสยืนยันใหม่อีกครั้งแล้ว',
    resend_after_seconds: 'ยังไม่ได้รับใช่ไหม? ขอรหัสใหม่ได้หลัง <span>{{seconds}}</span> วินาที',
    resend_passcode: 'ยังไม่ได้รับใช่ไหม? <a>ขอรหัสยืนยันใหม่</a>',
    create_account_id_exists: 'บัญชี {{value}} มีอยู่แล้ว ดำเนินการเข้าสู่ระบบต่อ',
    link_account_id_exists: 'บัญชี {{type}} {{value}} นี้มีอยู่แล้ว คุณต้องการเชื่อมโยงหรือไม่?',
    sign_in_id_does_not_exist: 'ไม่พบบัญชีสำหรับ {{value}} สร้างบัญชีใหม่หรือไม่?',
    sign_in_id_does_not_exist_alert: 'บัญชี {{type}} {{value}} นี้ยังไม่มีอยู่',
    create_account_id_exists_alert: 'บัญชี {{type}} {{value}} นี้ได้เชื่อมโยงกับบัญชีอื่นแล้ว โปรดลองใช้ {{type}} อื่น',
    social_identity_exist: '{{type}} {{value}} นี้ได้เชื่อมโยงกับบัญชีอื่นแล้ว โปรดลองใช้ {{type}} อื่น',
    bind_account_title: 'เชื่อมหรือสร้างบัญชี',
    social_create_account: 'คุณสามารถสร้างบัญชีใหม่ได้',
    social_link_email: 'คุณสามารถเชื่อมโยงอีเมลอื่น',
    social_link_phone: 'คุณสามารถเชื่อมโยงเบอร์โทรศัพท์อื่น',
    social_link_email_or_phone: 'คุณสามารถเชื่อมโยงอีเมลหรือเบอร์โทรศัพท์อื่น',
    social_bind_with_existing: 'เราพบบัญชีที่เกี่ยวข้องที่ได้ลงทะเบียนไว้แล้ว คุณสามารถเชื่อมโยงได้โดยตรง',
    skip_social_linking: 'ข้ามการเชื่อมบัญชีกับบัญชีที่มีอยู่?',
    reset_password: 'รีเซ็ตรหัสผ่าน',
    reset_password_description: 'กรอก {{types, list(type: disjunction;)}} ที่เชื่อมโยงกับบัญชีของคุณ แล้วเราจะส่งรหัสยืนยันเพื่อรีเซ็ตรหัสผ่าน',
    reset_password_magic_link_description: 'ป้อนที่อยู่อีเมลที่เชื่อมโยงกับบัญชีของคุณเพื่อดำเนินการรีเซ็ตรหัสผ่านต่อ',
    new_password: 'รหัสผ่านใหม่',
    set_password: 'ตั้งรหัสผ่าน',
    password_changed: 'เปลี่ยนรหัสผ่านแล้ว',
    no_account: 'ยังไม่มีบัญชีใช่ไหม? ',
    have_account: 'มีบัญชีอยู่แล้ว?',
    enter_password: 'กรอกรหัสผ่าน',
    enter_password_for: 'เข้าสู่ระบบด้วยรหัสผ่านสำหรับ {{method}} {{value}}',
    enter_username: 'ตั้งชื่อผู้ใช้',
    enter_username_description: 'ชื่อผู้ใช้สามารถใช้เข้าสู่ระบบแทนได้ ต้องประกอบด้วยตัวอักษร ตัวเลข และขีดล่างเท่านั้น',
    enter_username_policy_description: 'ชื่อผู้ใช้สามารถใช้เข้าสู่ระบบแทนได้ {{requirements}}',
    link_email: 'เชื่อมโยงอีเมล',
    link_phone: 'เชื่อมโยงเบอร์โทรศัพท์',
    link_email_or_phone: 'เชื่อมโยงอีเมลหรือเบอร์โทรศัพท์',
    link_email_description: 'เพื่อความปลอดภัยเพิ่มเติม กรุณาเชื่อมโยงอีเมลกับบัญชีของคุณ',
    link_phone_description: 'เพื่อความปลอดภัยเพิ่มเติม กรุณาเชื่อมโยงเบอร์โทรศัพท์กับบัญชีของคุณ',
    link_email_or_phone_description: 'เพื่อความปลอดภัยเพิ่มเติม กรุณาเชื่อมโยงอีเมลหรือเบอร์โทรศัพท์กับบัญชีของคุณ',
    continue_with_more_information: 'เพื่อความปลอดภัย กรุณากรอกรายละเอียดบัญชีด้านล่างให้ครบถ้วน',
    create_your_account: 'สร้างบัญชีของคุณ',
    sign_in_to_your_account: 'เข้าสู่บัญชีของคุณ',
    device_activation: 'เปิดใช้งานอุปกรณ์',
    device_activation_description: 'ป้อนรหัสที่แสดงบนอุปกรณ์ของคุณ ตรวจสอบให้แน่ใจว่าตรงกัน จากนั้นดำเนินการเข้าสู่ระบบบนอุปกรณ์นี้',
    device_activation_error_description: 'ป้อนรหัสที่แสดงบนอุปกรณ์ของคุณ',
    device_activation_success: 'อุปกรณ์ของคุณเชื่อมต่อแล้ว!',
    device_activation_success_description: 'กลับไปที่อุปกรณ์ของคุณเพื่อดำเนินการต่อ',
    no_region_code_found: 'ไม่พบรหัสประเทศ',
    verify_email: 'ยืนยันอีเมลของคุณ',
    verify_phone: 'ยืนยันหมายเลขโทรศัพท์ของคุณ',
    password_requirements: 'รหัสผ่านต้องมี {{items, list}}',
    password_requirement: {
        length_one: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
        length_two: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
        length_few: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
        length_many: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
        length_other: 'ต้องมีอย่างน้อย {{count}} ตัวอักษร',
        character_types_one: 'ต้องมีอย่างน้อย {{count}} ประเภทในตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์',
        character_types_two: 'ต้องมีอย่างน้อย {{count}} ประเภทในตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์',
        character_types_few: 'ต้องมีอย่างน้อย {{count}} ประเภทในตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์',
        character_types_many: 'ต้องมีอย่างน้อย {{count}} ประเภทในตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์',
        character_types_other: 'ต้องมีอย่างน้อย {{count}} ประเภทในตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และสัญลักษณ์',
    },
    username_requirements: 'ชื่อผู้ใช้{{items, list}}',
    username_requirement: {
        length: 'ต้องมี {{min}} ถึง {{max}} อักขระ',
        characters: 'มีได้เฉพาะ {{characters, list}} เท่านั้น',
    },
    username_character: {
        uppercase: 'ตัวพิมพ์ใหญ่',
        lowercase: 'ตัวพิมพ์เล็ก',
        number: 'ตัวเลข',
        underscore: 'ขีดล่าง',
    },
    use: 'ใช้',
    single_sign_on_email_form: 'กรอกอีเมลบริษัทของคุณ',
    single_sign_on_connectors_list: 'องค์กรของคุณได้เปิดใช้งาน Single Sign-On สำหรับอีเมล {{email}} คุณสามารถเข้าสู่ระบบผ่าน SSO ด้านล่างนี้',
    single_sign_on_enabled: 'บัญชีนี้เปิดใช้งาน Single Sign-On แล้ว',
    authorize_title: 'อนุมัติ {{name}}',
    unregistered_client_notice: 'แอปนี้ประกาศตัวเองโดย <hostname>{{host}}</hostname> รวมถึงชื่อและโลโก้ โปรดตรวจสอบชื่อโฮสต์ก่อนดำเนินการต่อ',
    request_permission: '{{name}} กำลังขอสิทธิ์เข้าถึง:',
    grant_organization_access: 'ให้สิทธิ์เข้าถึงองค์กร:',
    authorize_personal_data_usage: 'อนุญาตให้ใช้ข้อมูลส่วนตัวของคุณ:',
    authorize_organization_access: 'อนุญาตให้เข้าถึงองค์กรที่ระบุ:',
    user_scopes: 'ข้อมูลผู้ใช้ส่วนตัว',
    organization_scopes: 'การเข้าถึงองค์กร',
    authorize_agreement: `เมื่ออนุมัติการเข้าถึง ถือว่าคุณยอมรับ <link></link> ของ {{name}}`,
    authorize_agreement_with_redirect: `เมื่ออนุมัติการเข้าถึง ถือว่าคุณยอมรับ <link></link> ของ {{name}} และจะถูกเปลี่ยนหน้าไปยัง {{uri}}`,
    not_you: 'ไม่ใช่คุณใช่ไหม?',
    user_id: 'รหัสผู้ใช้: {{id}}',
    redirect_to: 'คุณจะถูกเปลี่ยนหน้าไปที่ {{name}}',
    auto_agreement: 'เมื่อดำเนินการต่อ ถือว่าคุณยอมรับ <link></link>',
    identifier_sign_in_description: 'กรอก {{types, list(type: disjunction;)}} เพื่อเข้าสู่ระบบ',
    all_sign_in_options: 'ตัวเลือกการเข้าสู่ระบบทั้งหมด',
    identifier_register_description: 'กรอก {{types, list(type: disjunction;)}} เพื่อสร้างบัญชีใหม่',
    all_account_creation_options: 'ตัวเลือกการสร้างบัญชีทั้งหมด',
    password_expired: 'รหัสผ่านของคุณหมดอายุแล้วและต้องรีเซ็ตก่อนจึงจะสามารถลงชื่อเข้าใช้ได้',
    password_expiration_reset: 'รีเซ็ตรหัสผ่าน',
    back_to_sign_in: 'กลับไปหน้าเข้าสู่ระบบ',
    support_email: 'อีเมลติดต่อ: <link></link>',
    support_website: 'เว็บไซต์สนับสนุน: <link></link>',
    switch_account_title: 'คุณกำลังเข้าสู่ระบบในชื่อ {{account}}',
    switch_account_description: 'ในการดำเนินการต่อ คุณจะออกจากบัญชีปัจจุบัน และสลับไปยังบัญชีใหม่โดยอัตโนมัติ',
    continue_to_app_title: 'กลับไปยังแอป',
    continue_to_app_description: 'ดำเนินการต่อเพื่อกลับไปยังแอป',
    about_yourself: 'บอกเราเกี่ยวกับตัวคุณ',
    verify_identity: 'ยืนยันตัวตนของคุณ',
    choose_verification_method: 'เลือกวิธีการเข้าสู่ระบบ',
    verification_method: {
        passkey: 'กุญแจรหัสผ่าน',
        passkey_description: 'ยืนยันผ่านอุปกรณ์หรือฮาร์ดแวร์ USB',
        password: 'รหัสผ่าน',
        password_description: 'กรอกรหัสผ่าน',
        email_verification_code: 'รหัสยืนยันทางอีเมล',
        phone_verification_code: 'รหัสยืนยันทางโทรศัพท์',
        verification_code_description: 'ส่งไปที่ {{target}}',
    },
    select_wallet: 'เลือกกระเป๋าเงิน',
};
export default Object.freeze(description);
